import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IMethod } from '../../../stores/model/metamodel/method';

/**
 * Check that:
 * - an object type doesn't have two owned methods for the same event.
 * - no two existence dependent object types have an owned method for the same
 *   event.
 */
class OwnedMethodEventOwningCheck extends Check<IMethod> {
  static description = 'Check event owning rule';

  check(): Report {
    this.report = new Report();

    const subject = this.element;

    if (subject.ownerObjectType == null) {
      // This can happen when a check for this method was added while converting from specialised
      // to normal method in the process of deleting the owner object
      return this.report;
    }

    for (const m of subject.ownerEventType.ownedMethods) {
      if (m === subject) continue;
      if (m.ownerObjectType === subject.ownerObjectType) {
        this.report.addMessage(
          MessageType.ERROR,
          `An object type cannot have two owned methods for the same event. \
          Found conflict in event ${subject.ownerEventType.asString()} between ${subject.asString()} and ${m.asString()}.`,
          this,
          subject
        );
      } else if (
        subject.ownerObjectType.isExistenceDependentOf(m.ownerObjectType) ||
        m.ownerObjectType.isExistenceDependentOf(subject.ownerObjectType)
      ) {
        this.report.addMessage(
          MessageType.ERROR,
          `If D is existence dependent of M, then D and M can not have an O/X for the same event. \
          Found conflict in event ${subject.ownerEventType.asString()} between ${subject.asString()} and ${m.asString()}.`,
          this,
          subject
        );
      }
    }

    return this.report;
  }
}

export default OwnedMethodEventOwningCheck;
